import React from 'react';
import profileImg from '../assets/Images-optimized/profile.webp';

const credentials = [
  { emoji: '🎓', text: 'BSc Computer Science, Ashesi University' },
  { emoji: '💻', text: 'Fullstack Developer' },
  { emoji: '📱', text: 'Mobile App Developer' },
  { emoji: '📊', text: 'Data Enthusiast' },
  { emoji: '📍', text: 'Based in Accra, Ghana' },
];

const Founder = () => {
  return (
    <section className="founder" id="founder">
      <div className="founder__header reveal">
        <div className="founder__label">{'// FOUNDER'}</div>
        <h2 className="founder__heading">
          Built by someone who's been in the room on both sides.
        </h2>
      </div>

      <div className="founder__grid">
        <div className="founder__photo reveal-left">
          <img src={profileImg} alt="Nana Banyin Ayeyi Djan" />
        </div>

        <div className="founder__content">
          <p className="founder__text reveal reveal-delay-1">
            Nana Banyin Ayeyi Djan is a full-stack software engineer and the
            founder of 200 OK Studios. He holds a BSc in Computer Science from
            Ashesi University, and has
            spent the last several years building backend systems, AI
            integrations, and scalable web platforms across EdTech, e-commerce,
            and research.
          </p>
          <p className="founder__text reveal reveal-delay-2">
            He started 200 OK Studios with one belief: that the right software,
            built correctly, changes how people work and what they're able to do.
            Everything being built here comes from that belief.
          </p>

          <div className="founder__credentials reveal reveal-delay-3">
            {credentials.map((c, i) => (
              <div className="founder__credential" key={i}>
                <span className="founder__credential-emoji">{c.emoji}</span>
                <span className="founder__credential-text">{c.text}</span>
              </div>
            ))}
          </div>

          <blockquote className="founder__quote reveal reveal-delay-4">
            <p>
              "Great software comes from understanding the problem deeply before
              choosing the tools. My approach is simple: listen first, design
              thoughtfully, build robustly, deliver reliably."
            </p>
            <cite>, Ayeyi</cite>
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default Founder;
